/** Convert a boolean-ish payload value to a SQLite integer (0/1), preserving null. */
export function optBool(v: unknown): number | null {
  if (v == null) return null;
  if (v === "0" || v === "false") return 0;
  return v ? 1 : 0;
}

/** String conversion that preserves null (avoids `String(null)` → `"null"`). */
export function str(v: unknown): string | null {
  return v == null ? null : String(v);
}
